import {html, css, LitElement} from 'lit';

export class ApiSwitch extends LitElement {

    static get properties() {
        return {
            state: { type: Boolean, reflect: true},
            entry: { type: String },
            event: { type: String },
        }
    }
    
    constructor() {
        super()
        this.state = false
    }

    connectedCallback() {
        super.connectedCallback()
        let comp = this
        
        window.addEventListener("focus", () => { comp.update() } )
        this.handler = () => {
            comp.update()
        }

        BX.addCustomEvent(this.event, this.handler)
    }

    disconnectedCallback() {
        super.disconnectedCallback()
        BX.removeCustomEvent(this.event, this.handler)
    }



    update() {
        super.update()
        let dataset = []
        for (const attr of this.attributes) {
            if (attr.name != "entry") {
                dataset[attr.name] = attr.value
            }
        }

        BX.ajax.runAction(
            this.entry, { 
                data: dataset
            }).then((resp) => {
                this.state = resp.data
            }, (err) => {
        })
    }

    render() {
        return html`
            <slot name="${this.state}"></slot>
        `
    }

}

customElements.define('api-switch', ApiSwitch)